export default "__VITE_ASSET__C0aasSG7__"